var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105.4 139",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00bf91"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.4,37.4c0-4.9-1-9.8-2.8-14.3c-1.9-4.5-4.6-8.7-8.1-12.1C91,7.5,86.9,4.7,82.4,2.8C77.8,1,73,0,68.1,0H37.4 C27.5,0,18,3.9,11,11C4,18,0.1,27.5,0.1,37.4v3.7H0V139h7.9c6.7,0,13.2-2.7,17.9-7.4c4.8-4.8,7.4-11.2,7.4-18V36.7 c0-1.8,1.4-3.4,3.2-3.4h31.6c0.5,0,1.1,0.1,1.6,0.3s1,0.5,1.3,0.9c0.4,0.4,0.7,0.8,0.9,1.3c0.2,0.5,0.3,1,0.3,1.6v34.3 c0,1.5-1.2,2.7-2.7,2.7h-1.2H68h-0.8c-3.3,0-6.6,0.7-9.7,1.9c-3.1,1.3-5.9,3.1-8.2,5.5c-2.4,2.4-4.2,5.2-5.5,8.2 c-1.3,3.1-1.9,6.4-1.9,9.7v7.9H68c9.9,0,19.4-3.9,26.4-11c7-7,10.9-16.5,10.9-26.5v-2.4h0.1V37.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.11a24208de3b3fa2df7f60a56c8cf06d.svg";
export { ForwardRef as ReactComponent };